import { BaseGQLService } from '../../../common/services/BaseGQLService';
import { FilterOperator, SorterSet } from '../../../common/types/gql-types';
import { CursorInfo, PaginationResult } from '../../../common/types/pagination';
import { ModelType } from '../../../common/utils/GQLIdEncoder';
import { HostMapper } from '../mappers/HostMapper';
import { Host } from '../models/Host';

export const GET_HOSTS_QUERY = `
query (
  $scanId: ID!,
  $first: Int,
  $last: Int,
  $after: String,
  $before: String,
  $filters: ScanHostsFilter,
  $sorters: [ScanHostsSorter]
) {
  node(id: $scanId) {
    ... on Scan {
      hosts(
        first: $first
        after: $after
        last: $last
        before: $before
        filters: $filters
        sorters: $sorters
      ) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            name
            status
            platform
            statusReason
            originId
            reportId
          }
        }
      }
    }
  }
}
`;

export class HostsService extends BaseGQLService {
  private readonly mapper = new HostMapper();

  async getList(scanId: number, cursor: CursorInfo, filters: FilterOperator | null, sorters: SorterSet[]): Promise<PaginationResult<Host>> {
    return this.query(
      GET_HOSTS_QUERY,
      {
        ...this.mapCursorInfo(cursor),
        filters,
        sorters: sorters,
        scanId: this.gqlIdEncoder.encode(ModelType.Scan, scanId),
      },
      (data) => {
        const { edges, pageInfo, totalCount } = data.node.hosts;
        return {
          data: edges.map(({ node }: any) => this.mapper.mapGQLModel(node)),
          pageInfo,
          totalCount,
        };
      }
    );
  }
}
